import { Directive, Input, ElementRef, Renderer2, OnChanges, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDisableRole]',
  standalone: false
})
export class DisableRoleDirective implements OnChanges {
  @Input() appDisableRole: string[] = [];
  @Input() currentRole: string = '';

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Optional() private ngControl: NgControl
  ) {}

  ngOnChanges() {
    const role = (this.currentRole || '').toUpperCase();
    const disableRoles = (this.appDisableRole || []).map(r => (r || '').toUpperCase());
    
    if (disableRoles.includes(role)) {
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
      this.renderer.addClass(this.el.nativeElement, 'disabled-by-role');
      if (this.ngControl && this.ngControl.control) {
        this.ngControl.control.disable({ emitEvent: false });
      }
    } else {
      this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
      this.renderer.removeClass(this.el.nativeElement, 'disabled-by-role');
      if (this.ngControl && this.ngControl.control) {
        this.ngControl.control.enable({ emitEvent: false });
      }
    }
  }
}
